/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

//
const HighlightSms = (props) => {
  const {
    smsSupport,
    phoneCode,
    smsCode,
    amountToPay,
  } = props;

  //
  const infoMessage = () => {
    if (get(globals, 'region', '') === 'lv') {
      return null;
    }

    const message = 'txt: Maksa par SMS {:price} {:currency} tiks pieskaitīt Jūsu mobilā telefona rēķinam.';
    return (
      <p className="tsl">
        {get(translations, message, message).replace('{:price}', amountToPay).replace('{:currency}', get(globals, 'currency'))}
      </p>
    );
  };

  //
  const phoneCodeMessage = () => {
    const message = 'txt: Nosūti sms uz numuru {:phone_code} ar kodu:';
    return get(translations, message, message).replace('{:phone_code}', phoneCode);
  };

  return (
    <div className="paymentOption-sms">
      <div className="paymentOption-vcenter mbxl">
        <div className="paymentOption-smallText">
          <div className="tsl twb mbs">
            {phoneCodeMessage()}
            <br />
          </div>
          <div className="tsxl twb mbxl tac">
            {smsCode}
          </div>
          <p className="tsl">
            {get(translations, 'txt: Jūsu profils tiks izcelts uzreiz pēc SMS nosūtīšanas!', 'Profils tiks izcelts uzreiz pēc SMS nosūtīšanas!')}
          </p>
          {infoMessage()}
          <p className="tsl">
            {get(translations, smsSupport, smsSupport)}
          </p>
        </div>
      </div>
      <div className="paymentOption-smallText pts">
        <a href="/payments/highlight/3" data-target="#content" className="paymentOption-back">
          {get(translations, 'txt: Izvēlēties citu maksāšanas metodi', 'Izvēlēties citu maksāšanas metodi')}
        </a>
      </div>
    </div>
  );
};

HighlightSms.propTypes = {
  smsSupport: PropTypes.string.isRequired,
  phoneCode: PropTypes.string.isRequired,
  smsCode: PropTypes.string.isRequired,
  amountToPay: PropTypes.number.isRequired,
};

export default HighlightSms;
